const browserOrigin =
  typeof window === 'undefined' ? '' : window.location.origin

const config = Object.freeze({
  env:
    process.env.REACT_APP_ENV ||
    (process.env.NODE_ENV === 'production' ? 'PROD' : 'DEV'),
  PHONE: process.env.REACT_APP_SUPPORT_PHONE || '',

  // Public OAuth identifiers only. Never add app secrets or provider tokens here.
  REACT_APP_FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || '',
  REACT_APP_GOOOGLE_APP_ID:
    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    process.env.REACT_APP_GOOOGLE_APP_ID ||
    '',

  API_V2:
    process.env.REACT_APP_API_V2 ||
    'https://api-cambodia.evoshop.cam/api/v2',
  API_V3:
    process.env.REACT_APP_API_V3 ||
    'https://api-cambodia.evoshop.cam/api/v3',
  API:
    process.env.REACT_APP_API ||
    'https://api-cambodia.evoshop.cam/api/v3',
  WS: process.env.REACT_APP_WS_URL || '',
  HREF: process.env.REACT_APP_PUBLIC_URL || browserOrigin,
})

export default config
